import React from 'react'
import { Button } from 'primereact/button';
import { Calendars } from '../../../components/Calendar/Calendar';
import { useHistory } from "react-router-dom";

export default function P303Search({ searchDate, setSearchDate, searchForm, history }) {

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setSearchDate({
            ...searchDate,
            [`${key}`]: val,
        });
    };

    return (
        <div className="p-fluid p-formgrid p-grid">

            <div className="p-field p-col-12 p-md-4">
                <label>ระยะเวลาข้อมูลจาก</label>
                <Calendars maxLength="10"
                    key="dateBegin"
                    id="dateBegin"
                    value={new Date(searchDate.dateBegin)}
                    onChange={(e) => onInputTextChange(e, "dateBegin")}
                // minDate={new Date(formObject.announce_start_date)}
                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <label>ถึงวันที่</label>
                <Calendars
                    maxLength="10"
                    key="dateEnd"
                    id="dateEnd"
                    value={new Date(searchDate.dateEnd)}
                    onChange={(e) => onInputTextChange(e, "dateEnd")}
                // minDate={new Date(formObject.announce_start_date)}
                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <div style={{ display: 'flex', marginTop: '33px', marginBottom: '10px' }} >
                    <Button
                        className="p-button p-button btn-long-top-responsive"
                        icon="pi pi-search"
                        label="ค้นหา"
                        // style={{width:'120'}}
                        onClick={() => searchForm(searchDate)}
                    />
                    <Button
                        className="p-button-secondary p-button btn-long-top-responsive"
                        icon="pi pi-arrow-left"
                        label="กลับหน้าจอหลัก"
                        style={{ width: 170, marginLeft: "5px" }}
                        onClick={() => {
                            history.push("/302");
                        }}
                    />
                </div>
            </div>


        </div>
    )
}
